import { defineStore } from "pinia"
import { ref, computed } from "vue"

const BASEMAP_URL =
    "https://iprpraha.maps.arcgis.com/sharing/rest/content/items/50f872ac3f85435baf86c2443b247af7/resources/styles/root.json"
const KLOK_URL =
    "https://gp-dc.iprpraha.cz/arcgis/rest/services/app_klok/klok/MapServer/0"
const BORDERS_URL =
    "https://gs-pub.praha.eu/arcgis/rest/services/map/zakladni_mapa/MapServer/0"

export const useKlokStore = defineStore("klok", () => {
    const mainStore = useMainStore()

    const viewReady = ref<boolean>(false)
    const isFetching = ref<boolean>(false)
    const basemapUrl = ref<string>(BASEMAP_URL)
    const klokUrl = ref<string>(KLOK_URL)
    const cityBordersUrl = ref<string>(BORDERS_URL)
    const mode = ref<"mesto" | "struktura">("mesto")
    const selectedLocality = ref<KlokLokalitaItem | null>(null)
    const selectedMetrika = ref<KlokMetrikaItem | null>(null)
    const selectedStructure = ref<number | null>(null)
    const settings = ref<KlokSettings | null>(null)
    const settingsReady = ref<boolean>(false)
    const layerOpacity = ref<number>(1)
    const searchInput = ref<string>("")
    const searchedLocality = ref<string | null>(null)
    const localitiesForSearch = ref<
        {
            id: number
            cislo: string
            nazev: string
        }[]
    >([])

    const filteredSuggestions = computed(() => {
        if (searchInput.value.length < 3) return []
        return localitiesForSearch.value.filter(
            locality =>
                includesWithoutDiacritics(locality.nazev, searchInput.value) ||
                locality.cislo.includes(searchInput.value)
        )
    })

    const fetchSettings = async () => {
        isFetching.value = true
        try {
            const response = await $fetch<KlokSettings>("klok-settings", {
                baseURL: mainStore.apiBaseUrl,
            })
            settings.value = response

            settings.value.metriky.sort((a, b) => a.PORADI - b.PORADI)
            settingsReady.value = true
        } catch (error) {
            console.error("Error fetching Klok settings", error)
            alert("Nastala chyba při načítání nastavení Katalogu lokalit.")
        } finally {
            isFetching.value = false
        }
    }

    const includesWithoutDiacritics = (str1: string, str2: string) => {
        const str1WithoutDiacritics = str1
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
        const str2WithoutDiacritics = str2
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
        return str1WithoutDiacritics.includes(str2WithoutDiacritics)
    }

    return {
        viewReady,
        basemapUrl,
        klokUrl,
        cityBordersUrl,
        mode,
        selectedLocality,
        selectedMetrika,
        selectedStructure,
        settings,
        settingsReady,
        layerOpacity,
        searchInput,
        searchedLocality,
        localitiesForSearch,
        isFetching,
        filteredSuggestions,
        fetchSettings,
    }
})

/* type KlokStore = {
    viewReady: boolean
    isFetching: boolean
    basemapUrl: string
    klokUrl: string
    cityBordersUrl: string
    mode: "mesto" | "struktura"
    selectedLocality: KlokLokalitaItem | null
    selectedMetrika: KlokMetrikaItem | null
    selectedStructure: number | null
    settings: KlokSettings | null
    settingsReady: boolean
    layerOpacity: number
    searchInput: string
    searchedLocality: string | null
    localitiesForSearch: {
        id: number
        cislo: string
        nazev: string
    }[]
}

const BASEMAP_URL =
    "https:////iprpraha.maps.arcgis.com/sharing/rest/content/items/50f872ac3f85435baf86c2443b247af7/resources/styles/root.json"
const KLOK_URL =
    "https://gp-dc.iprpraha.cz/arcgis/rest/services/app_klok/klok/MapServer/0"
const BORDERS_URL =
    "https://gs-pub.praha.eu/arcgis/rest/services/map/zakladni_mapa/MapServer/0"

const useKlokStore = defineStore("klok", {
    state: (): KlokStore => ({
        viewReady: false,
        isFetching: false,
        basemapUrl: BASEMAP_URL,
        klokUrl: KLOK_URL,
        cityBordersUrl: BORDERS_URL,
        mode: "mesto",
        selectedLocality: null,
        selectedMetrika: null,
        selectedStructure: null,
        settings: null,
        settingsReady: false,
        layerOpacity: 1,
        searchInput: "",
        searchedLocality: null,
        localitiesForSearch: [],
    }),
    getters: {
        filteredSuggestions(state) {
            if (state.searchInput.length < 3) return []
            return state.localitiesForSearch.filter(
                locality =>
                    locality.nazev
                        .toLowerCase()
                        .includes(state.searchInput.toLowerCase()) ||
                    locality.cislo.includes(state.searchInput)
            )
        },
    },
    actions: {
        async fetchSettings() {
            this.isFetching = true
            try {
                const response = await $fetch<KlokSettings>("klok-settings", {
                    baseURL: useMainStore().apiBaseUrl,
                })
                this.settings = response

                this.settings.metriky.sort((a, b) => a.PORADI - b.PORADI)
                this.settingsReady = true
            } catch (error) {
                console.error("Error fetching Klok settings", error)
                alert("Nastala chyba při načítání nastavení Katalogu lokalit.")
            } finally {
                this.isFetching = false
            }
            // Fetch settings from the server
        },
    },
})

if ((import.meta as MetaHot).hot) {
    ;(import.meta as MetaHot).hot?.accept(
        acceptHMRUpdate(useKlokStore, (import.meta as MetaHot).hot)
    )
}

export { useKlokStore } */
